
import React from 'react';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { useLanguage } from '@/hooks/useLanguage';
import { CheckCircle } from 'lucide-react';
import { Helmet } from 'react-helmet';

const Advantages = () => {
  const { t } = useLanguage();

  const advantages = [
    {
      title: 'Personalized Approach',
      description: 'I take the time to understand your unique business needs and objectives, ensuring all deliverables are perfectly aligned with your vision and goals.'
    },
    {
      title: 'Quality Equipment',
      description: 'Using state-of-the-art cameras, lighting, and editing software to ensure the highest quality results for your projects.'
    },
    {
      title: 'Fast Turnaround',
      description: 'Efficient project management and workflow processes mean you get your content when you need it without sacrificing quality.'
    },
    {
      title: 'Affordable Packages',
      description: 'Competitive pricing structures designed to fit businesses of all sizes, from startups to established enterprises.'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <main className="relative z-10 pt-24">
	  <Helmet>
        <title>Vorteile | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin</title>
        <meta name="description" content="Entdecken Sie die Vorteile einer Zusammenarbeit mit Matthias Meyfarth aus Berlin – professionelle Videografie, Fotografie und Webdesign auf höchstem Niveau." />
        <meta property="og:title" content="Vorteile | Matthias Meyfarth – Videograf, Fotograf & Webdesigner aus Berlin" />
        <meta property="og:description" content="Professionelle visuelle Inhalte von Matthias Meyfarth aus Berlin – erfahren Sie, warum Unternehmen und Marken auf seine Expertise setzen." />
        <meta property="og:type" content="website" />
      </Helmet>
        <section className="content-section">
          <div className="container mx-auto px-6 py-24">
            <h1 className="text-4xl font-bold mb-8">{t('Advantages')}</h1>
            <p className="text-xl mb-12 text-muted-foreground max-w-3xl mx-auto text-center">
              {t('Why Choose My Services')}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
              {advantages.map((advantage, index) => (
                <div key={index} className="flex p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow">
                  <div className="flex-shrink-0 mr-4 text-primary">
                    <CheckCircle className="h-8 w-8" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold mb-2">{t(advantage.title)}</h3>
                    <p className="text-muted-foreground">{t(advantage.description)}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Advantages;
